function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import FocusTrapper from './FocusTrapper';
/**
 * Will ensure tabbing within the trap element is circular and focus
 * does not leave within the components life time.
 *
 * ## Related Components
 * -[Dialog](../Dialog/README.md)
 * -[DropdownMenu](../DropdownMenu/README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <FocusTrap
 *   as="aside"
 *   onEscape={() => console.log('esc pressed')}
 *   allowArrowKeys={false}
 * >
 *    <Button ctaType="secondary">Button 1</Button>
 *    <Button ctaType="primary">Button 2</Button>
 * </FocusTrap>
 * ```
 *
 * ## Props
 */

var FocusTrap = /*#__PURE__*/function (_PureComponent) {
  _inherits(FocusTrap, _PureComponent);

  var _super = _createSuper(FocusTrap);

  function FocusTrap(props) {
    var _this;

    _classCallCheck(this, FocusTrap);

    _this = _super.call(this, props);
    _this._node = props.node || /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(FocusTrap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._initFocusTrap();

      this.directFocus();
    } // Ensure focus is still trapped as needed if the component re-renders

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.directFocus();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.focus) {
        this.focus.release();
        delete this.focus;
      }
    }
  }, {
    key: "_initFocusTrap",
    value: function _initFocusTrap() {
      if (this.focus || !this._node.current) return;
      var _this$props = this.props,
          onEscape = _this$props.onEscape,
          allowArrowKeys = _this$props.allowArrowKeys,
          allowTabTraversal = _this$props.allowTabTraversal,
          strategy = _this$props.strategy;
      this.focus = new FocusTrapper(this._node.current, {
        allowArrowKeys: allowArrowKeys,
        allowTabTraversal: allowTabTraversal,
        strategy: strategy
      });
      this.focus.trap();
      this.focus.setOnEscape(onEscape); // Anchored / Popper.js positions the element at 0, 0 then transforms it. This will cause
      // the browser window to scroll to top to show the focused element.
    }
  }, {
    key: "directFocus",
    value: function directFocus() {
      if (!this.focus) return;
      var trap = this.props.trap;

      if (trap) {
        this.focus.trap();
      } else {
        this.focus.release();
      }
    } // eslint-disable-next-line no-unused-vars

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          node = _this$props2.node,
          children = _this$props2.children,
          BaseComponent = _this$props2.as,
          includeWrapper = _this$props2.includeWrapper;
      var elProps = Object.assign({}, this.props);
      delete elProps.onEscape;
      delete elProps.node;
      delete elProps.forwardedRef;
      delete elProps.allowArrowKeys;
      delete elProps.allowTabTraversal;
      delete elProps.strategy;
      delete elProps.trap;
      delete elProps.includeWrapper;
      if (node && !includeWrapper) return children;
      return /*#__PURE__*/React.createElement(BaseComponent, _extends({
        ref: this._node
      }, elProps));
    }
  }]);

  return FocusTrap;
}(PureComponent);

export { FocusTrap as default };
FocusTrap.defaultProps = {
  onEscape: function onEscape() {},
  node: null,
  allowArrowKeys: true,
  allowTabTraversal: true,
  strategy: 'tabbable',
  trap: true,
  as: 'div',
  includeWrapper: false
};
FocusTrap.propTypes = {
  /**
   *  A passed in ref, if one is not passed in the one will be created
   */
  node: PropTypes.shape({
    current: PropTypes.any
  }),

  /**
   *  Whether or not to allow arrow keys to switch focus
   */
  allowArrowKeys: PropTypes.bool,

  /**
   * Whether or not to allow tabbing within the focus trap, if disabled
   * pressing tab will call onEscape and will exit the trap. For menus
   * this should be disabled letting only arrow keys traverse the options so
   * users can exit long lists of options with tab
   */
  allowTabTraversal: PropTypes.bool,

  /**
   * Whether to select focusable or tabbable elements. The distinction is subtle but
   * normally tabbable elements with tabindex of -1 will be focusable but not tabbable.
   * The 'focusable' strategy should be used for menus.
   */
  strategy: PropTypes.oneOf(['tabbable', 'focusable']),

  /**
   * event callback called when a user presses the ESC key
   */
  onEscape: PropTypes.func,

  /**
   * Any UI component tree to render within the trap
   */
  children: PropTypes.node.isRequired,

  /**
   * Whether to trap focus or not
   */
  trap: PropTypes.bool,

  /**
   * When not forwarding ref choose what element should be used to wrap
   * (i.e. "div", "aside", "section"...)
   */
  as: PropTypes.elementType,

  /**
   * Whether to include a wrapping component or not. A wrapping component is
   * necessary when forwarding a ref. This prop was added to disambiguate the
   * default behavior which was to prefer not including a wrapping element in
   * favor of a previously established node.
   */
  includeWrapper: PropTypes.bool
};